import { render, staticRenderFns } from "./Turnover.vue?vue&type=template&id=82c8b590&scoped=true"
import script from "./Turnover.vue?vue&type=script&lang=js"
export * from "./Turnover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c8b590",
  null
  
)

export default component.exports